import { BsPercent } from "react-icons/bs";
import "../../../styles/stores/stockManagement/stockDetails.css";
import { useState, useEffect } from "react";
import { addSalesUrl } from "../../../api/endpoints";
import { ButtonLoader } from "../../../components/uxCollections/Loaders";
import { getAllData, saveData } from "../../../tools/indexdb";
import { useSelector } from "react-redux";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const AddSales = ({ closeModal, changePage, product, storeID, currency, updateSelectedProduct, storeName }) => {
  const [salesPrice, setSalesPrice] = useState("");
  const [salesDuration, setSalesDuration] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isDiscountPriceValid, setIsDiscountPriceValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //
  const { employee } = useSelector((state) => state.employee);

  useEffect(() => {
    console.log(salesPrice, salesDuration);
    if (salesPrice && parseInt(salesPrice) < parseInt(product.unitPrice)) {
      setIsDiscountPriceValid(true);
    } else {
      setIsDiscountPriceValid(false);
    }
  }, [salesPrice, salesDuration]);

  useEffect(() => {
    if (salesPrice && salesDuration && isDiscountPriceValid) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
    console.log(isFormValid);
  }, [isDiscountPriceValid, salesPrice, salesDuration]);

  const addSales = async () => {
    setIsLoading(true);
    let accessToken = localStorage.getItem("accessToken");
    let addSalesPayload = {
      productID: product._id,
      salesPrice,
      salesDuration,
      employee,
    };
    if (isFormValid) {
      try {
        let response = await fetch(addSalesUrl + storeID, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(addSalesPayload),
        });
        if (response.ok) {
          let { storeProductCollection, modifiedProduct } = await response.json();
          updateSelectedProduct(modifiedProduct);
          let storeData = await getAllData(storeName);

          if (storeData) {
            storeData.storeProductCollection = storeProductCollection.products;

            closeModal(true);
            await saveData(storeName, storeData);
            uiAlert("Sales added successfully", "success");
            // changePage("stockManagement");
            setIsLoading(false);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  /* currentPrice={product.unitPrice} productID={product._id} storeID={store._id} */

  return (
    <>
      <div onClick={() => closeModal(false)} className='addSalesWrapper2'>
        <div className='addSalesContainer' onClick={(e) => e.stopPropagation()}>
          <h4 style={{ textAlign: "center", marginBottom: "20px" }}>Add Sales</h4>
          <p className='salesTagtitl3643'>Current unit price {currency} </p>
          <div className='oldPriceDIv32'>
            <p> {product.unitPrice.toLocaleString()} </p>
          </div>
          <p className='salesTagtitl3643'>
            {" "}
            discount price {currency}{" "}
            {product.onSales && <span style={{ color: "rgb(173 154 6)" }}>{`(currently on sale at ${currency}${product.discountPrice})`}</span>}{" "}
          </p>
          <div className='oldPriceDIv32'>
            <input
              value={salesPrice}
              onChange={(e) => setSalesPrice(e.target.value)}
              className='salesPriceIn34'
              type='number'
              placeholder='Enter sales price'
            />
          </div>
          {salesPrice && !isDiscountPriceValid && <span> discount price must be lower than current price </span>}
          <p className='salesTagtitl3643'> Sales duration (days) </p>
          <div className='oldPriceDIv32'>
            <input
              value={salesDuration}
              onChange={(e) => setSalesDuration(parseInt(e.target.value) > 60 ? 60 : e.target.value)}
              className='salesPriceIn34'
              type='number'
              placeholder='60 days maximum'
            />
          </div>
          {isFormValid ? (
            isLoading ? (
              <div className='addSalesbtnDiv343'>
                <button disabled style={{ cursor: "not-allowed", opacity: "0.7", backgroundColor: "#4c5370" }} className='addSalesBtn234'>
                  {/* <BsPercent /> Add Sales */}
                  <ButtonLoader />
                </button>
              </div>
            ) : (
              <div className='addSalesbtnDiv343'>
                <button onClick={addSales} className='addSalesBtn234'>
                  <BsPercent /> Add Sales
                </button>
              </div>
            )
          ) : (
            <div className='addSalesbtnDiv343'>
              <button disabled style={{ cursor: "not-allowed", opacity: "0.7", backgroundColor: "#4c5370" }} className='addSalesBtn234'>
                <BsPercent /> Add Sales
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddSales;
